import type {
  GroupSummaryValueExtractor,
  Renderer,
  SummaryExtractor,
} from "@/components/controls/grid/BmGridData";
import {
  BmGridSummaryConfiguration,
  SummaryPlacement,
} from "@/components/controls/grid/BmGridData";

export class SummaryBuilder<T, V> {
  protected readonly _summary: BmGridSummaryConfiguration;

  constructor(
    extractor: SummaryExtractor,
    aggregator: GroupSummaryValueExtractor
  ) {
    this._summary = new BmGridSummaryConfiguration(extractor, aggregator, {});
  }

  public build(): BmGridSummaryConfiguration {
    return this._summary;
  }

  public alignWithGroupedColumn(columnKey: string) {
    this._summary.placement = SummaryPlacement.Column;
    this._summary.columnKey = columnKey;
    return this;
  }

  public withRenderer(renderer: Renderer) {
    this._summary.renderer = renderer;
    return this;
  }

  public withSuffixExtractor(suffixExtractor: (item: any, value: any) => any) {
    this._summary.rendererMetadata.suffixExtractor = suffixExtractor;
    return this;
  }
}

export class NumberSummaryBuilder<T> extends SummaryBuilder<T, number | null> {
  constructor(
    extractor: SummaryExtractor,
    aggregator: GroupSummaryValueExtractor
  ) {
    super(extractor, aggregator);
  }
}

export class IconSummaryBuilder<T> extends SummaryBuilder<T, number | null> {
  constructor(
    extractor: SummaryExtractor,
    aggregator: GroupSummaryValueExtractor
  ) {
    super(extractor, aggregator);
  }
}
